export default __webpack_public_path__ + "static/media/lp-new-ganzkoerper-exercise-01.5c6af36c.jpg";